module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-ttl"
  }, [_c('i', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/dedication#c1",
      "id": "t1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/authors_note#c2",
      "id": "t2"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#c3",
      "id": "t3"
    }
  }, [_vm._v("Merle Kilgore")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#c4",
      "id": "t4"
    }
  }, [_vm._v("Hank Williams, Sr.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#c5",
      "id": "t5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Webb Pierce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#c6",
      "id": "t6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faron Young")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#c7",
      "id": "t7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elvis Presley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#c8",
      "id": "t8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johnny Horton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#c9",
      "id": "t9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clifton Clowers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#c10",
      "id": "t10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johnny Cash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#c11",
      "id": "t11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hank Williams, Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#c12",
      "id": "t12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bocephus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#c13",
      "id": "t13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Senator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#c14",
      "id": "t14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daddy Merle")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0